import { ravenSDKTrigger } from '@/analytics/raven/ravenSDKHelper'

// Bridges loyalty attrs from the banner to the shared login modal, so the login funnel
// emits elite-specific events only when login was launched from a loyalty surface.
const LOYALTY_LOGIN_CONTEXT_KEY = 'loyalty_login_context'

export type LoyaltyLoginPayload = Record<string, string | number | null>

export const setLoyaltyLoginContext = (payload: LoyaltyLoginPayload): void => {
    if (typeof window === 'undefined') {
        return
    }
    try {
        window.sessionStorage.setItem(LOYALTY_LOGIN_CONTEXT_KEY, JSON.stringify(payload))
    } catch {
        /* no-op */
    }
}

// reads and clears in one shot so it can't leak into a later, non-loyalty login
export const consumeLoyaltyLoginContext = (): LoyaltyLoginPayload | null => {
    if (typeof window === 'undefined') {
        return null
    }
    try {
        const raw = window.sessionStorage.getItem(LOYALTY_LOGIN_CONTEXT_KEY)
        if (!raw) {
            return null
        }
        window.sessionStorage.removeItem(LOYALTY_LOGIN_CONTEXT_KEY)
        return JSON.parse(raw) as LoyaltyLoginPayload
    } catch {
        return null
    }
}

export const fireLoyaltyLoginEvent = (
    eventName: string,
    payload: LoyaltyLoginPayload,
    actionName?: string
): void => {
    ravenSDKTrigger(eventName, {
        ...payload,
        ...(actionName ? { action_name: actionName } : {})
    })
}
